import { z } from 'zod';

import { makeFeatureFlagPayloadValidator } from './utils';

export const booleanFeatureFlag = makeFeatureFlagPayloadValidator({
  defaultEnabled: false,
  schema: z.object({}),
  defaultValue: {},
});
